export default __webpack_public_path__ + "static/media/user.e14bddca.svg";